import type { Drama } from "./types";

export const dramas: Drama[] = [
  {
    id: "silent-tide",
    title: "静默的潮汐",
    originalTitle: "静かな潮",
    year: 2023,
    region: "日本",
    director: "白石 遥",
    cast: ["小林沙耶", "藤堂 修", "中村千寻", "長谷川 亮"],
    types: ["伦理剧情", "家庭", "悬疑"],
    category: "ethics-family",
    episodes: 10,
    runtime: 48,
    rating: 9.2,
    premiere: "2023-04-12",
    broadcaster: "海原电视台 木曜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20woman%20standing%20on%20a%20wooden%20pier%20facing%20a%20calm%20grey%20sea%20at%20dawn%2C%20wind%20lifting%20her%20dark%20coat%2C%20minimal%20muted%20palette%2C%20cinematic%20portrait%20with%20soft%20grain%2C%20editorial%20poster%20feel&width=600&height=800&seq=drama-silent-tide-01&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20quiet%20seaside%20town%20in%20Japan%20at%20dawn%2C%20grey%20ocean%20and%20misty%20hills%2C%20small%20wooden%20houses%20with%20warm%20window%20lights%2C%20moody%20desaturated%20tones%20with%20a%20single%20orange%20sun%20glow&width=1600&height=900&seq=drama-silent-tide-wide-01&orientation=landscape",
    tagline: "她替邻居养了十七年的孩子，如今生母要来带走他。",
    summary:
      "一场车祸让两个家庭的名字被写进同一份文件。十七年后，秘密随着海水一起上岸，所有人都必须重新回答那个问题：母亲究竟由什么定义？",
    intro: [
      "海原市的冬天总是起雾。在港口小镇经营洗衣店的桐岛真纪，用十七年时间把一个不属于自己的孩子养大。直到某个落雪的清晨，一位从东京来的女人站在店门口，说她才是遥人的母亲。",
      "剧集没有急于给出道德判决，而是把镜头留在厨房、洗衣机的滚筒、以及母子三人各自的沉默里。真纪的丈夫在第五集才第一次开口谈起当年，而那次谈话只有四分钟，却成为全年最常被讨论的场景。",
      "《静默的潮汐》采用章节体结构，每两集换一个叙述视角。观众在第一集同情真纪，第七集开始理解那位生母，到最后一集发现，真正无从选择的是那个孩子。",
    ],
    tags: ["养育权", "海域小镇", "群像", "秘密"],
    hot: 98,
    updatedAt: "2023-06-14",
    specialIds: ["family-web", "quiet-voices"],
    editorNote: "以水声代替配乐的尝试非常大胆，第二集结尾长达四十秒的无声镜头，是整部剧的锚点。",
  },
  {
    id: "borrowed-light",
    title: "借来的光",
    originalTitle: "借りた光",
    year: 2024,
    region: "日本",
    director: "三宅 桂",
    cast: ["松井 绫子", "大西 透", "菅原 美咲"],
    types: ["伦理爱情", "剧情"],
    category: "ethics-love",
    episodes: 8,
    runtime: 52,
    rating: 8.9,
    premiere: "2024-01-18",
    broadcaster: "AOY 深夜剧",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20couple%20standing%20apart%20in%20a%20narrow%20lantern-lit%20alley%2C%20side%20profile%20portraits%2C%20warm%20orange%20lamp%20glow%20against%20deep%20navy%20shadows%2C%20restrained%20melancholic%20expression%2C%20cinematic%20film%20still&width=600&height=800&seq=drama-borrowed-light-02&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20street%20in%20old%20Tokyo%20district%20with%20hanging%20lanterns%20and%20reflective%20wet%20pavement%2C%20two%20distant%20figures%20walking%20apart%2C%20deep%20navy%20tones%20with%20warm%20orange%20highlights%2C%20anamorphic%20glow&width=1600&height=900&seq=drama-borrowed-light-wide-02&orientation=landscape",
    tagline: "她把婚戒寄存进当铺的第一天，遇见了十七岁时的恋人。",
    summary:
      "婚姻走到第八年，麻衣决定把婚戒当掉换成房租。柜台后抬起头的，是当年不告而别的恋人。八集的篇幅，足够让两个人在克制与靠近之间来回走很多遍。",
    intro: [
      "这不是一部关于出轨的剧，而是一部关于「如果当年」的剧。三宅桂把大量篇幅留给两人在便利店、停车场和地铁末班车上的对话，每一句都礼貌得体，每一次停顿都危险。",
      "第八集没有发生任何越界行为，却在最后五分钟让所有观众屏住呼吸。编剧在访谈中提到，结局的设计原则是「让两位主角都保有可以面对早晨的能力」。",
    ],
    tags: ["旧爱重逢", "婚姻", "克制", "夜景"],
    hot: 94,
    updatedAt: "2024-03-07",
    specialIds: ["forbidden-house"],
    editorNote: "深夜剧的篇幅反而成就了它，暧昧被拉长到几乎可以听见秒针。",
  },
  {
    id: "the-inheritance-room",
    title: "继承人的房间",
    originalTitle: "相続人の部屋",
    year: 2022,
    region: "日本",
    director: "大瀬 隆一",
    cast: ["戸田 誠", "桜井 千代", "水野 建", "吉岡 すみれ"],
    types: ["伦理家庭", "悬疑", "法庭"],
    category: "ethics-family",
    episodes: 11,
    runtime: 54,
    rating: 9.0,
    premiere: "2022-10-05",
    broadcaster: "北辰放送 水曜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20traditional%20Japanese%20room%20with%20an%20open%20wooden%20scroll%20box%20containing%20a%20folded%20document%2C%20single%20beam%20of%20light%20through%20shoji%20screen%2C%20deep%20grey%20tones%20with%20amber%20highlight%2C%20symbolic%20cinematic%20still&width=600&height=800&seq=drama-inheritance-room-03&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Elegant%20old%20Japanese%20mansion%20interior%20with%20long%20corridor%20and%20sliding%20paper%20doors%2C%20shafts%20of%20afternoon%20light%2C%20empty%20tatami%20room%2C%20muted%20charcoal%20and%20warm%20wood%20tones%2C%20architectural%20cinematography&width=1600&height=900&seq=drama-inheritance-room-wide-03&orientation=landscape",
    tagline: "父亲留下的不是遗产，是一份需要所有人签字的秘密。",
    summary:
      "知名建筑师的葬礼上，律师宣读了第十七版遗嘱。四名子女被要求在同一间房里住满三十天，才能获得各自的份额。",
    intro: [
      "一部几乎全在室内完成的剧。大瀬隆一把家族老宅拍成一座迷宫，走廊的每个转角都藏着一个未被说出口的往事。",
      "剧本对法律程序的考据相当扎实，继承份额、代书遗嘱、特留分这些术语被自然地织进对话里，甚至被不少法学院拿来当案例讨论的引子。",
    ],
    tags: ["遗产", "家族群像", "密室", "法律"],
    hot: 91,
    updatedAt: "2022-12-21",
    specialIds: ["family-web"],
    editorNote: "第四集晚餐戏，四个人、一道汤、零句真话，是近年最精彩的室内调度。",
  },
  {
    id: "white-noise-ward",
    title: "白噪音病栋",
    originalTitle: "ホワイトノイズ病棟",
    year: 2024,
    region: "日本",
    director: "宮本 悠",
    cast: ["高橋 隼人", "西村 まどか", "石井 悟"],
    types: ["伦理职场", "医疗", "社会"],
    category: "ethics-workplace",
    episodes: 9,
    runtime: 50,
    rating: 8.7,
    premiere: "2024-07-09",
    broadcaster: "KRD 火曜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=Lone%20male%20doctor%20in%20white%20coat%20standing%20in%20a%20dim%20hospital%20corridor%20at%20night%2C%20green-white%20fluorescent%20light%20against%20grey%20blue%20shadows%2C%20tense%20restrained%20expression%2C%20cinematic%20medical%20drama%20still&width=600&height=800&seq=drama-white-noise-ward-04&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Empty%20modern%20hospital%20nurse%20station%20at%20night%20with%20scattered%20charts%20and%20dim%20fluorescent%20lighting%2C%20cold%20grey%20teal%20palette%2C%20one%20warm%20lamp%2C%20cinematic%20wide%20shot%20with%20subtle%20grain&width=1600&height=900&seq=drama-white-noise-ward-wide-04&orientation=landscape",
    tagline: "他签署的第一份隐瞒，是为了救一个不该被救的人。",
    summary:
      "地方医院的重症科医生在一次夜间值班中，发现上级伪造了手术记录。举报、沉默、还是加入——九集的时间，让他把这个问题的每个答案都试了一遍。",
    intro: [
      "医疗剧的外壳，职场伦理的内核。剧中大量的会议场景几乎不加配乐，让组织压力的重量通过纸张、键盘和走廊脚步声传达出来。",
      "主角并不是英雄。他在第三集选择了沉默，第五集又试图用另一种方式弥补，这种摇摆让整部剧的道德讨论变得诚实。",
    ],
    tags: ["医疗伦理", "举报", "组织压力", "制度"],
    hot: 88,
    updatedAt: "2024-09-03",
    specialIds: ["quiet-voices"],
    editorNote: "对「沉默的共谋」的描写极为准确，每个旁观者都有自己的理由。",
  },
  {
    id: "showa-kitchen",
    title: "昭和厨房",
    originalTitle: "昭和の台所",
    year: 2021,
    region: "日本",
    director: "森下 澄子",
    cast: ["加藤 春子", "藤本 和也", "佐野 ゆかり", "町田 誠一"],
    types: ["年代", "伦理家庭", "温情"],
    category: "era-showa",
    episodes: 12,
    runtime: 45,
    rating: 9.4,
    premiere: "2021-04-04",
    broadcaster: "NHB 日曜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20Japanese%20kitchen%20from%20the%201970s%20with%20cast%20iron%20pot%20steaming%2C%20tiled%20counter%2C%20small%20window%20with%20soft%20afternoon%20light%2C%20muted%20brown%20and%20cream%20palette%2C%20film%20photography%20grain&width=600&height=800&seq=drama-showa-kitchen-05&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Nostalgic%201970s%20Japanese%20residential%20street%20with%20small%20shops%2C%20bicycles%20leaning%20on%20walls%2C%20late%20afternoon%20golden%20light%2C%20muted%20sepia%20and%20olive%20tones%2C%20warm%20cinematic%20film%20grain&width=1600&height=900&seq=drama-showa-kitchen-wide-05&orientation=landscape",
    tagline: "一间只摆得下两张桌子的食堂，煮了三十年的家事。",
    intro: [
      "昭和五十年，东京郊外的「春食堂」。老板娘每天只做四道菜，来的人却把一生都带来了。",
      "剧集以一年一集的方式跨越三十年，同一张餐桌上的座位不断换人，碗筷却始终是同一套。最后一集，已经年迈的春子把店重新开门，只为了等一个不会再来的人。",
      "没有激烈的冲突，伦理的重量藏在「留下」与「离开」这两个简单动作里。",
    ],
    summary:
      "战后第三十年开业的小食堂，用十二集的长度讲述一个家族、一条街道与一个时代的变迁。",
    tags: ["昭和", "食堂", "代际", "暖色调"],
    hot: 96,
    updatedAt: "2021-06-20",
    specialIds: ["showa-index"],
    editorNote: "料理镜头全部实拍，没有一道菜是道具。这是近年最温柔的伦理叙事。",
  },
  {
    id: "silent-witness-24",
    title: "证人的二十四小时",
    originalTitle: "証人の24時間",
    year: 2023,
    region: "日本",
    director: "比嘉 亮介",
    cast: ["佐伯 玲", "森 拓真", "大塚 清美"],
    types: ["伦理剧情", "法律", "悬疑"],
    category: "ethics-drama",
    episodes: 6,
    runtime: 44,
    rating: 8.5,
    premiere: "2023-11-10",
    broadcaster: "网络独播",
    cover:
      "https://readdy.ai/api/search-image?query=Woman%20in%20a%20grey%20blazer%20sitting%20alone%20in%20a%20dim%20interrogation%20room%2C%20single%20overhead%20light%20casting%20strong%20shadow%2C%20restrained%20tense%20expression%2C%20cool%20navy%20grey%20cinematic%20palette&width=600&height=800&seq=drama-silent-witness-06&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Empty%20Japanese%20courtroom%20at%20night%20with%20rows%20of%20wooden%20benches%20and%20single%20lit%20lamp%2C%20dramatic%20shadow%2C%20cool%20grey%20tones%20with%20faint%20amber%20glow%2C%20cinematic%20symmetry&width=1600&height=900&seq=drama-silent-witness-wide-06&orientation=landscape",
    tagline: "她只剩一天时间，决定要不要说出那句真话。",
    summary:
      "六集，二十四小时。一名目击证人在案件开庭前夕，被三方力量同时施压，剧情完全按实时推进。",
    intro: [
      "实时叙事的结构让观众和主角同步失去睡眠。每一集结尾都停在同一个时钟刻度上，形成奇特的压迫感。",
      "剧本刻意淡化了案件的猎奇性，把焦点放在证人本身的日常处境：她的工作、她的孩子、她无法承担的后果。",
    ],
    tags: ["实时叙事", "法庭", "证人", "时间压力"],
    hot: 85,
    updatedAt: "2023-12-01",
    specialIds: ["quiet-voices"],
    editorNote: "第六集没有反转，只有一句迟到的话，却比任何反转都更有力量。",
  },
  {
    id: "two-mothers",
    title: "两个母亲的春天",
    originalTitle: "二人の母",
    year: 2024,
    region: "日本",
    director: "篠原 圭",
    cast: ["田辺 真由", "藤森 かな", "長田 学"],
    types: ["伦理家庭", "温情"],
    category: "ethics-family",
    episodes: 10,
    runtime: 47,
    rating: 8.8,
    premiere: "2024-04-13",
    broadcaster: "海原电视台 土曜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20Japanese%20women%20of%20different%20ages%20sitting%20on%20a%20park%20bench%20with%20cherry%20blossom%20petals%20falling%2C%20gentle%20restrained%20expressions%2C%20soft%20pink%20white%20light%20with%20navy%20shadows%2C%20cinematic%20portrait%20still&width=600&height=800&seq=drama-two-mothers-07&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Quiet%20Japanese%20suburban%20park%20in%20spring%20with%20blooming%20cherry%20trees%20and%20a%20single%20bench%2C%20soft%20pale%20light%2C%20muted%20pink%20and%20slate%20grey%20tones%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=drama-two-mothers-wide-07&orientation=landscape",
    tagline: "一个孩子，两个母亲，春分那天他们决定一起养。",
    summary:
      "养母与生母在同一座城市生活，为了孩子的入学问题不得不第一次面对面坐下。十集之后，她们成了一种新的家人。",
    intro: [
      "这是本栏目收录的少数以温柔为基调的作品。冲突依旧存在，但剧本把大量篇幅留给了具体的协作：谁接放学、谁签家长通知书、谁在发烧的夜里守着。",
    ],
    tags: ["养母", "生母", "春天", "共同养育"],
    hot: 90,
    updatedAt: "2024-06-22",
    specialIds: ["family-web", "spring-lineup"],
    editorNote: "没有反派的一部伦理剧，每个人都只是想对孩子好，这才是最难的部分。",
  },
  {
    id: "borrowed-name",
    title: "借名之夜",
    originalTitle: "名を借りる夜",
    year: 2022,
    region: "日本 / 合拍",
    director: "李 智源",
    cast: ["金城 澪", "朴 ソンウ", "坂口 覚"],
    types: ["伦理剧情", "悬疑", "社会"],
    category: "ethics-drama",
    episodes: 8,
    runtime: 55,
    rating: 8.6,
    premiere: "2022-02-17",
    broadcaster: "国际合拍单元",
    cover:
      "https://readdy.ai/api/search-image?query=Man%20standing%20under%20a%20rain-soaked%20overpass%20holding%20a%20torn%20passport%2C%20teal%20grey%20night%20palette%20with%20orange%20street%20lamp%20glow%2C%20grainy%20cinematic%20portrait&width=600&height=800&seq=drama-borrowed-name-08&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Rainy%20Japanese%20port%20district%20at%20night%20with%20shipping%20containers%20and%20orange%20sodium%20lamps%2C%20wet%20asphalt%20reflections%2C%20deep%20teal%20shadows%2C%20cinematic%20anamorphic%20wide%20shot&width=1600&height=900&seq=drama-borrowed-name-wide-08&orientation=landscape",
    tagline: "他用了别人的名字活了十二年，现在那个人回来了。",
    summary:
      "一名外来劳工在九十年代的港口城市借用他人身份生活，十二年后真正的名字回来了。关于身份、尊严与日常的伦理故事。",
    intro: [
      "合拍背景让这部剧拥有更复杂的语言层次，日语、韩语与闽南语在同一个屋檐下交错，字幕本身就是叙事的一部分。",
    ],
    tags: ["身份", "港口", "合拍", "移民"],
    hot: 82,
    updatedAt: "2022-04-09",
    specialIds: ["quiet-voices"],
    editorNote: "对「被看见」的渴望描述得非常具体，是这一类题材中少有克制的作品。",
  },
  {
    id: "the-quiet-lawyer",
    title: "沉默的第一课",
    originalTitle: "沈黙の第一課",
    year: 2025,
    region: "日本",
    director: "安藤 千景",
    cast: ["藤井 玲奈", "北村 俊", "小野 ふみ"],
    types: ["伦理职场", "法律", "成长"],
    category: "ethics-workplace",
    episodes: 10,
    runtime: 46,
    rating: 8.4,
    premiere: "2025-01-16",
    broadcaster: "AOY 木曜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=Young%20Japanese%20female%20lawyer%20in%20a%20charcoal%20suit%20holding%20a%20document%20folder%20in%20a%20stairwell%2C%20soft%20daylight%20from%20a%20high%20window%2C%20calm%20determined%20expression%2C%20muted%20slate%20grey%20palette&width=600&height=800&seq=drama-quiet-lawyer-09&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Law%20office%20bookshelf%20corridor%20with%20warm%20reading%20lamps%20and%20stacks%20of%20documents%2C%20late%20afternoon%20light%20through%20glass%2C%20muted%20wood%20and%20slate%20tones%2C%20editorial%20cinematic%20still&width=1600&height=900&seq=drama-quiet-lawyer-wide-09&orientation=landscape",
    tagline: "她接手的第一个案子，原告是她自己的家人。",
    summary:
      "新人律师在入职第一周接下一起家族内部诉讼，必须在职业伦理与家庭情分之间，找到属于自己的第一句判词。",
    intro: [
      "成长线与伦理困境交织的典型作品。剧本把大量的「不知道该说什么」写成台词，反而让主角的成长显得可信。",
    ],
    tags: ["新人律师", "家族诉讼", "成长", "对白密集"],
    hot: 87,
    updatedAt: "2025-03-27",
    specialIds: ["spring-lineup"],
    editorNote: "第九集的庭前和解戏，是全剧的伦理核心，值得反复看。",
  },
  {
    id: "blue-hour-shop",
    title: "蓝调时分的杂货店",
    originalTitle: "ブルーアワーの雑貨店",
    year: 2025,
    region: "日本",
    director: "木村 史",
    cast: ["夏川 結衣", "岡田 健", "和田 さくら"],
    types: ["当代都市", "伦理爱情", "治愈"],
    category: "era-modern",
    episodes: 9,
    runtime: 43,
    rating: 8.3,
    premiere: "2025-07-08",
    broadcaster: "TOB 金曜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20Japanese%20general%20store%20at%20blue%20hour%20with%20warm%20interior%20lamps%20and%20vintage%20goods%20in%20the%20window%2C%20deep%20blue%20exterior%20with%20orange%20glow%2C%20cozy%20cinematic%20street%20portrait&width=600&height=800&seq=drama-blue-hour-shop-10&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Narrow%20Japanese%20shopping%20street%20at%20blue%20hour%20with%20small%20illuminated%20shops%20and%20bicycle%2C%20deep%20indigo%20sky%20with%20warm%20orange%20window%20lights%2C%20cinematic%20urban%20photography&width=1600&height=900&seq=drama-blue-hour-shop-wide-10&orientation=landscape",
    tagline: "她为邻居保管的东西，一年后变成了别人的全部回忆。",
    summary:
      "东京下町的一间杂货店，替街坊寄存那些「暂时不想带回家」的东西。每一集，一件旧物带出一个被推迟的选择。",
    intro: [
      "以单元剧形式推进，主线是店主与一位常客之间缓慢靠近的关系。伦理的重量在于：有些照顾，其实是占有。",
    ],
    tags: ["都市", "旧物", "单元剧", "治愈"],
    hot: 84,
    updatedAt: "2025-09-12",
    specialIds: ["spring-lineup"],
    editorNote: "蓝调时分的光线设计非常统一，几乎每张截图都能当海报。",
  },
  {
    id: "the-returned-daughter",
    title: "回来的女儿",
    originalTitle: "帰ってきた娘",
    year: 2020,
    region: "日本",
    director: "高梨 誠",
    cast: ["大野 麻子", "森川 保", "宮下 麻衣"],
    types: ["伦理家庭", "悬疑"],
    category: "ethics-family",
    episodes: 8,
    runtime: 51,
    rating: 8.9,
    premiere: "2020-10-14",
    broadcaster: "北辰放送 水曜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=Young%20woman%20in%20a%20beige%20coat%20standing%20at%20the%20gate%20of%20a%20traditional%20Japanese%20house%20at%20dusk%2C%20back%20to%20camera%20with%20subtle%20face%20turn%2C%20muted%20amber%20and%20grey%20cinematic%20portrait&width=600&height=800&seq=drama-returned-daughter-11&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Traditional%20Japanese%20house%20exterior%20at%20dusk%20with%20stone%20path%20and%20wooden%20gate%2C%20warm%20light%20spilling%20from%20windows%2C%20muted%20dusk%20palette%20with%20amber%20highlights%2C%20cinematic%20still&width=1600&height=900&seq=drama-returned-daughter-wide-11&orientation=landscape",
    tagline: "失踪十五年的女儿回来了，可她记得的事情全都对不上。",
    summary:
      "失踪十五年的女儿突然回家，全家在欣喜中慢慢察觉到不对。八集里，每个人都必须面对自己当年隐瞒了什么。",
    intro: [
      "以家庭剧的节奏推进悬疑，几乎每一集都用一顿饭的时间完成一次信息揭示。最后一集的反转并非为了惊吓，而是把「家」这个概念的裂痕彻底摊开。",
    ],
    tags: ["失踪", "身份疑问", "家族秘密", "反转型"],
    hot: 89,
    updatedAt: "2020-12-02",
    specialIds: ["family-web", "showa-index"],
    editorNote: "第六集母亲的一句话，把全剧此前所有温情场面都重新定义了。",
  },
  {
    id: "salaryman-ethic",
    title: "科长的沉默",
    originalTitle: "課長の沈黙",
    year: 2019,
    region: "日本",
    director: "矢野 正人",
    cast: ["山口 恒一", "木下 あかり", "真田 誠"],
    types: ["伦理职场", "社会"],
    category: "ethics-workplace",
    episodes: 7,
    runtime: 49,
    rating: 8.2,
    premiere: "2019-06-21",
    broadcaster: "KRD 火曜剧场",
    cover:
      "https://readdy.ai/api/search-image?query=Middle-aged%20Japanese%20salaryman%20in%20navy%20suit%20standing%20alone%20on%20a%20train%20platform%20at%20late%20night%2C%20fluorescent%20light%2C%20tired%20restrained%20expression%2C%20muted%20grey%20blue%20cinematic%20portrait&width=600&height=800&seq=drama-salaryman-ethic-12&orientation=portrait",
    wide:
      "https://readdy.ai/api/search-image?query=Japanese%20office%20floor%20late%20at%20night%20with%20empty%20desks%20and%20glowing%20monitors%2C%20cold%20grey%20blue%20palette%20with%20one%20warm%20desk%20lamp%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=drama-salaryman-ethic-wide-12&orientation=landscape",
    tagline: "一个数字，三十七个人，只有他看得懂。",
    summary:
      "中层管理者发现部门数据造假，向上汇报的每一步都在把自己推向悬崖。七集篇幅，写尽组织伦理的日常形态。",
    intro: [
      "剧本采访了大量真实企业员工，会议室里的句式几乎可以直接搬用。最刺人的不是反派，而是那些说「我理解你」的同事。",
    ],
    tags: ["职场", "数据造假", "中年", "组织"],
    hot: 79,
    updatedAt: "2019-08-15",
    specialIds: ["quiet-voices"],
    editorNote: "「我没有反对，我只是没说话」这句台词，后来成了社交媒体上的流行语。",
  },
];

export const findDrama = (id?: string) => dramas.find((item) => item.id === id);